import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";


export default function LoginButton() {

    const { instance } = useMsal();

    const handleLogin = async () => {

        try {

            const response = await instance.loginPopup(loginRequest);

            instance.setActiveAccount(response.account);

        }
        catch (error) {

            console.error(error);

        }

    };

    return (

        <button onClick={handleLogin}>

            Iniciar sesión

        </button>

    );

}
